import { AFFINITIES, CHARACTERS, CLANS } from './content.js';
import { normalizeRanks } from './rules.js';

export const SAVE_KEY = 'shinobi-duel-progress';
export const SAVE_VERSION = 3;

const defaults = {
  version: SAVE_VERSION,
  level: 1,
  xp: 0,
  coins: 0,
  statPoints: 0,
  powerPoints: 0,
  stats: { atk: 0, def: 0, spd: 0, chakra: 0 },
  character: 'kaito',
  clan: 'arashi',
  affinity: 'gale',
  unlockedCharacters: ['kaito'],
  mastery: {},
  skillRanks: { attack: 1, rasengan: 1, clones: 1, wind: 1 },
  records: { victories: 0, bossesDefeated: 0, coinsEarned: 0 },
  achievements: [],
  settings: { sound: true, reducedEffects: false, screenShake: true },
};

function safeNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

export function migrateSave(raw = {}) {
  const character = CHARACTERS[raw.character] ? raw.character : defaults.character;
  const hero = CHARACTERS[character];
  const clan = CLANS[raw.clan] ? raw.clan : hero.clan;
  const affinity = AFFINITIES[raw.affinity] ? raw.affinity : hero.affinity;
  const mastery = Object.fromEntries(Object.keys(AFFINITIES).map((id) => {
    const entry = raw.mastery?.[id] || {};
    return [id, { level: Math.max(1, safeNumber(entry.level, 1)), xp: Math.max(0, safeNumber(entry.xp)) }];
  }));
  return {
    ...defaults,
    ...raw,
    version: SAVE_VERSION,
    level: Math.max(1, safeNumber(raw.level, 1)),
    xp: Math.max(0, safeNumber(raw.xp)),
    coins: Math.max(0, safeNumber(raw.coins)),
    statPoints: Math.max(0, safeNumber(raw.statPoints)),
    powerPoints: Math.max(0, safeNumber(raw.powerPoints)),
    stats: { ...defaults.stats, ...(raw.stats || {}) },
    character,
    clan,
    affinity,
    mastery,
    skillRanks: normalizeRanks(raw.skillRanks),
    records: { ...defaults.records, ...(raw.records || {}) },
    achievements: Array.isArray(raw.achievements) ? [...new Set(raw.achievements)] : [],
    unlockedCharacters: [...new Set(['kaito', ...(Array.isArray(raw.unlockedCharacters) ? raw.unlockedCharacters.filter((id) => CHARACTERS[id]) : [])])],
    settings: { ...defaults.settings, ...(raw.settings || {}) },
  };
}

export function loadProgress(storage = localStorage) {
  try {
    return migrateSave(JSON.parse(storage.getItem(SAVE_KEY) || '{}'));
  } catch {
    return migrateSave();
  }
}

export function saveProgressData(progress, storage = localStorage) {
  storage.setItem(SAVE_KEY, JSON.stringify({ ...progress, version: SAVE_VERSION }));
}
